import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import ClientRoute from './Routes/ClientRoute';
import AdminRoute from './Routes/AdminRoutes';
import Login from './Pages/Login';
import Home from './Pages/Home';
import Layout from './Components/Layout';

function App() {
  return (
    <Router>
      <Routes>
        {/* Wrap Home with Layout inside the element prop */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/login" element={<Login />} />
        <Route path="/Client/*" element={<ClientRoute />} />
        <Route path="/Admin/*" element={<AdminRoute />} />
      </Routes>
    </Router>
  );
}

export default App;
